export function GetProductionStatusColorByNumber(status: number) {
	switch (status) {
		case 10:
			return "#1DFF00";
		case 50:
		case 60:
		case 70:
		case 80:
		case 90:
		case 100:
			return "#FFA500";
		case 20:
		case 40:
		case 110:
		case 120:
		case 30:
			return "red";
		default:
			return "blue";
	}
}